import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../tooltip';
import { cn } from '@utils';

const DELAY_DURATION = 100;

export interface SimpleTooltipProps extends React.ComponentProps<typeof TooltipProvider> {
	asChild?: boolean;
	children: React.ReactNode;
	content: string | React.ReactNode;
	ariaLabel?: string;
	disabled?: boolean;
	className?: string;
	contentClassName?: string;
	side?: React.ComponentProps<typeof TooltipContent>['side'];
	avoidCollisions?: boolean;
}

export const SimpleTooltip = ({
	children,
	content,
	asChild,
	delayDuration = DELAY_DURATION,
	ariaLabel,
	disabled,
	className,
	contentClassName,
	side,
	avoidCollisions,
	...props
}: SimpleTooltipProps) => {
	return (
		<TooltipProvider delayDuration={delayDuration} {...props} data-testid="simple-tooltip">
			<Tooltip open={disabled ? false : undefined}>
				<TooltipTrigger
					className={cn(disabled ? 'cursor-default' : 'cursor-pointer', className)}
					asChild={asChild}
					type="button"
					aria-label={ariaLabel}
				>
					{children}
				</TooltipTrigger>
				<TooltipContent className={contentClassName} side={side} avoidCollisions={avoidCollisions}>
					{content}
				</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	);
};
